import { GiftServices } from '../services';
import { GiftConstants } from '../constants';
import { alertActions } from '.';

export const GiftAction = {
    getAll,
    loadingData,
    exportData,
};
function getAll(obj) {
    return dispatch => {
        dispatch(request());
        GiftServices.GetAllGifts(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: GiftConstants.GETALL_REQUEST } }
    function success(datas) { return { type: GiftConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: GiftConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: GiftConstants.GETALL_FAILURE, error } }
    // function response(error) {return {type: GiftConstants.GETALL_RESPONCE,data}} 
}
function exportData(obj) {
    return dispatch => {
        dispatch(request());
        GiftServices.GetAllGifts(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });               
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
                dispatch(alertActions.error(error.toString));
                dispatch(failure(error.toString()));
            });
    };
    function request() { return { type: GiftConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: GiftConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: GiftConstants.GETEXPORT_FAILURE, error } }
}
function loadingData(isbool) {
    return {
        type: GiftConstants.LOADING_REQUEST, isbool
    }
}